// This file is AUTOGENERATED, do not edit it manually!!!

export const common = {
    CanDeleteCategoryHasTask: 'Nie jest możliwe usunąć kategorii, które są używane w działaniach.',
    CanDeleteVacationTypeDefault: 'Nie jest możliwe usunąć domyślnony typ wakacji.',
    CanDeleteVacationTypeHasVacation: 'Nie jest możliwe usunąć typ wakacji, który ma przypisany wakacje.',
    Completed_Projects: 'Zakończone projekty',
    Completed_Tasks: 'Zakończone działalności',
    filters: 'Filtry',
    next_month: 'Następny miesiąc',
    next_week: 'Nastepny tydzień',
    previous_month: 'Poprzedni miesiąc',
    previous_week: 'Poprzedni tydzień',
    previous_year: 'Poprzedni rok',
    select: 'Wybierz',
    short_quarter0: 'I kw.',
    short_quarter1: 'II kw.',
    short_quarter2: 'III kw.',
    short_quarter3: 'IV kw.',
    this_month: 'Ten miesiąc',
    this_week: 'Ten tydzień',
    this_year: 'Ten rok',
    today: 'Dzisiaj',
    yesterday: 'Wczoraj',
};
